import React from 'react';
import './Fpv.css';
import FpvRtc from './FpvRtc';
import { ModemData } from '../../../api/Drone';

type FpvProps = {
    drone: ModemData;
    onClose: () => void;
};

const Fpv: React.FC<FpvProps> = ({ drone, onClose }) => {
    return (
        <div className="fpv">
            <FpvRtc drone={drone} onClose={onClose} />
        </div>
    );
};

export default Fpv;